module.exports = __webpack_public_path__ + "static/media/018.a709249d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/018.jpg
// module id = 365
// module chunks = 0